import React from 'react';
import { Box, ButtonV2, TextV2 } from '@withjoy/joykit';
import { Play } from '@withjoy/joykit/icons';
import { useMediaQuery } from '@withjoy/joykit/utils';
import { pxToRem } from '@withjoy/joykit/theme';
import { HighlightProps } from './Highlight';

export const HighlightContent = ({
  title,
  eyebrow,
  text,
  colorMode,
  type,
  variant,
  buttonLabel,
  padding,
  showCtaIcon,
  onButtonClick
}: Pick<HighlightProps, 'title' | 'eyebrow' | 'text' | 'colorMode' | 'type' | 'buttonLabel' | 'variant' | 'padding' | 'showCtaIcon'> & { onButtonClick?: () => void }) => {
  const isMobileScreen = useMediaQuery(theme => theme.mediaQueries.between(0, { breakpointAlias: 'sm2' }));
  return (
    <Box zIndex={2} padding={padding}>
      {eyebrow?.length && (
        <TextV2 typographyVariant="hed2" paddingBottom={3}>
          {eyebrow}
        </TextV2>
      )}
      <TextV2
        typographyVariant={type === 'primary' ? [variant === 'babyOverview' ? 'display2' : 'display3', 'display4'] : 'hed6'}
        fontSize={type === 'primary' ? [null, pxToRem(48)] : null}
        whiteSpace="pre-wrap"
      >
        {title}
      </TextV2>
      {variant === 'babyOverview' && type === 'primary' && isMobileScreen && text?.length && (
        <TextV2 typographyVariant="body1" paddingTop={5}>
          {text}
        </TextV2>
      )}
      <ButtonV2
        width={variant === 'babyOverview' && type === 'primary' && isMobileScreen ? '100%' : 'auto'}
        marginTop={6}
        intent="neutral"
        variant={colorMode === 'light' ? 'ghost' : 'solid'}
        backgroundColor={colorMode === 'light' ? 'white' : null}
        shape="rounded"
        startIcon={showCtaIcon && <Play />}
        onClick={onButtonClick}
      >
        {buttonLabel}
      </ButtonV2>
    </Box>
  );
};
